// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__bnwJ6","contextHolder":"contextHolder__XNyCT","context":"context__dCKLG"};